module.exports = __webpack_public_path__ + "img/routers.81791207.svg";